import React from "react";

const UserPaymentReceipts: React.FC = () => {
  return <div>UserPaymentReceipt</div>;
};

export default UserPaymentReceipts;
